import React from "react";
import { groupBy, isEmpty } from "lodash";
import {
  GetTaskSchedulesBuilding,
  GetTaskSchedulesPlace,
} from "core/queries/GetTaskSchedules";
import { BuildingListItem } from "schedule/components/BuildingListItem";
import { useStore as useTasksStore } from "tasks/store";

interface BuildingListProps {
  buildings: GetTaskSchedulesBuilding[] | undefined;
  places: GetTaskSchedulesPlace[] | undefined;
}

export const BuildingList = ({ buildings, places }: BuildingListProps) => {
  const {
    state: {
      filters: { buildingIds },
    },
  } = useTasksStore();
  const groupedPlaces = groupBy(places, "building.id");
  return (
    <>
      {buildings &&
        buildings
          .filter(building => {
            const isSelected = !isEmpty(buildingIds)
              ? buildingIds?.includes(building.id)
              : true;
            return isSelected;
          })
          .map(building => (
            <BuildingListItem
              building={building}
              key={building.id}
              places={groupedPlaces[building.id]}
            />
          ))}
    </>
  );
};
